(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('ObjectTestResult', ObjectTestResult);

    ObjectTestResult.$inject = ['$resource', 'DateUtils'];

    function ObjectTestResult ($resource, DateUtils) {
        var resourceUrl =  'api/object-test-result/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'execute': { url: 'api/object-test-result-execute', method:'PUT'},
            'retrieveObjectTest': {
                url: 'api/object-test-result-object/:object',
                method: 'GET',
                isArray: true
            },
            'retrieveAutoOrManualObjectTest': { //per avere solo test automatici o solo test manuali
                url: 'api/object-test-result-object/automatic-or-manual/:object',
                method: 'GET',
                isArray: true
            },
            // 'testsForScheduling': { url:'api/object-test-result/tests-for-scheduling', method: 'GET', isArray: true},
            'bySchedule': {
                url: "api/object-test-result/by-test-schedule/:id",
                method: 'GET',
                isArray: true
            },
            'numberOfTestsBySchedule': {
                url: "api/number-of-tests/by-test-schedule/:id",
                method: 'GET',
                isArray: true
            },
            'historyObjectTest': {
                url: 'api/object-test-result-history/:object',
                method: 'GET',
                isArray: true
            },
            'deletePdf': {
                url: 'api/object-test-remove-pdf/:name/:type',
                method: 'GET'
            },
            'byTags' : {
                method: 'GET',
                url: 'api/object-test-result-object/automatic-or-manual-tag/:object',
                isArray:true}
        });
    }
})();
